const formatCurrency = (value) =>
    new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(Number(value) || 0);

export default function Spender({ members = [] }) {
    return (
        <div className="max-w-7xl px-4 sm:px-6 lg:px-8 pt-4 pb-12 lg:pt-6 lg:pb-24 mx-auto">
            <div className="mb-6 sm:mb-10 max-w-2xl text-center mx-auto">
                <h1 className="font-medium text-foreground text-3xl sm:text-4xl">Penjualan Terbaru</h1>
                <p className="mt-2 text-sm text-muted-foreground-1">Tampilkan seluruh pembelian hari ini</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
                {members.length === 0 ? (
                    <div className="col-span-full rounded-xl border border-card-line bg-card px-4 py-8 text-center text-sm text-muted-foreground-1">
                        Belum ada data penjualan.
                    </div>
                ) : (
                    members.map((member) => (
                        <div key={member.so_id} className="rounded-xl border border-card-line bg-card p-5 shadow-2xs">
                            <div className="flex items-center gap-4">
                                <img
                                    src={member.photo_url}
                                    alt={member.name}
                                    className="h-16 w-16 rounded-full object-cover border border-layer-line"
                                />
                                <div>
                                    <h3 className="text-base font-semibold text-foreground">{member.name}</h3>
                                    <p className="mt-1 text-sm text-muted-foreground-1">Nilai Pembelian</p>
                                    <p className="text-lg font-semibold text-foreground">{formatCurrency(member.purchase_value)}</p>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}
